export default __webpack_public_path__ + "static/media/water11.f1b449c3.png";